/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_JQ_74_81 as Componente_JQ_74_81,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_XQ as XQ,
  rec_YQ as YQ,
  rec_ZQ as ZQ,
} from "../../runtime/index.jsx";
export function Componente_qQ_113_81(e) {
  let t = (0, ReactCompiler.c)(15),
    { orden: n } = e,
    r,
    i,
    a,
    o,
    s;
  if (t[0] !== n.solicitudes) {
    s = Symbol.for(`react.early_return_sentinel`);
    bb0: {
      let e = (n.solicitudes ?? []).filter(ZQ);
      if (e.length === 0) {
        s = null;
        break bb0;
      }
      let c = e.filter(XQ),
        l = e.filter(YQ),
        u = e.length - c.length - l.length,
        d = c.length === 0 && l.length === e.length;
      a = `rounded-xl border p-2 text-xs ${d ? `border-(--error)` : `border-(--border)`}`;
      let f = d
        ? `Todos avisaron que no iban.`
        : `Avisaron que iban ${c.length} de ${e.length}` +
          (u > 0 ? `, y ${u} no contestó nada.` : `.`);
      (t[6] === f
        ? (o = t[7])
        : ((o = <p className={`mb-1 text-(--text)`} children={f} />),
          (t[6] = f),
          (t[7] = o)),
        (r = `flex flex-col gap-0.5`),
        (i = l.map(Componente_JQ_74_81)));
    }
    ((t[0] = n.solicitudes),
      (t[1] = r),
      (t[2] = i),
      (t[3] = a),
      (t[4] = o),
      (t[5] = s));
  } else ((r = t[1]), (i = t[2]), (a = t[3]), (o = t[4]), (s = t[5]));
  if (s !== Symbol.for(`react.early_return_sentinel`)) return s;
  let c;
  t[8] !== r || t[9] !== i
    ? ((c = <ul className={r} children={i} />),
      (t[8] = r),
      (t[9] = i),
      (t[10] = c))
    : (c = t[10]);
  let l;
  return (
    t[11] !== a || t[12] !== o || t[13] !== c
      ? ((l = <div className={a} children={[o, c]} />),
        (t[11] = a),
        (t[12] = o),
        (t[13] = c),
        (t[14] = l))
      : (l = t[14]),
    l
  );
}
